<template lang="pug">
  .header__language(
    :class="{ 'header__language_open': active }"
    v-if="showDropdown"
    v-tap="toggle"
    v-tap-outside="hide"
  )
    .header__language-arrow
    .header__language-link(
      :class="`header__language-link_${lang.title}`"
      v-for="lang in availableLanguages"
      :key="lang.lang"
      v-tap="() => changeLocale(lang.lang)"
    )
      .header__language-link-lang {{ lang.title }}
</template>

<script>
import { mapState } from 'vuex'
import { SEARCH_PARAMS } from '@/constants/searchParams'

export default {
  name: 'HeaderTopLanguage',
  data: () => ({
    active: false
  }),
  computed: {
    ...mapState('main', ['languages', 'location']),
    availableLanguages: vm => vm.languages.sort(item => item.lang === vm.$i18n.locale ? -1 : 1),
    showDropdown: vm => vm.languages.length > 1
  },
  methods: {
    changeLocale (locale) {
      if (this.$i18n.locale !== locale) {
        this.$router.replace({ query: { ...this.$route.query, [SEARCH_PARAMS.LANGUAGE]: locale } })
        location.reload()
      }
    },
    hide () {
      this.active = false
    },
    toggle () {
      this.active = !this.active
    }
  }
}
</script>
